import { CreditAlert } from '../ui/credit-alert'
import { connect, mapProps } from '@formily/react'

export const FormilyCreditAlert = connect(
  CreditAlert,
  mapProps((props) => ({
    ...props,
  })),
)
